import { Bar } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import { useGetByIdAndTimeSummarizedQuery } from '../../services/historicalData'
import { LoadingView } from '../LoadingView'
import { useStyletron } from 'baseui';
import { addMonths } from 'date-fns/esm';
import { addDays, addMinutes, endOfDay, startOfDay } from 'date-fns';
import { useMemo, useState } from 'react';
import { mapHistoryGroupItemsToChartItemsMonth } from './utils';
import { BarChartProps } from './types';
import { defaultDataSet, defaultOptions } from './defaultOptions';
import { useGetLanguage } from '../../hooks/useGetLanguage';
import { Block } from 'baseui/block';
import { addAlpha } from '../../utils/colorUtils';
import { NoData } from './NoData';
import { Button } from 'baseui/button';
import { CSVDownload, CSVLink } from "react-csv";
import { KIND } from 'baseui/button';
import { PiFileCsvLight } from "react-icons/pi";
import TimeNavigation from '../../features/Charts/TimeNavigation/TimeNavigation';

const weekOffset = -31;

const BarChartMonth = (props: BarChartProps) => {
  const { id, responsive, color } = props;

  const current = new Date();
  const { locale } = useGetLanguage();
  const [, theme] = useStyletron();
  const timezoneOffset = (new Date()).getTimezoneOffset() * -1;
  const [state, setState] = useState({ start: addMonths(addMinutes(new Date(current.getFullYear(), current.getMonth(), current.getDate()), timezoneOffset), -11), end: addDays(addMinutes(new Date(current.getFullYear(), current.getMonth(), current.getDate()), timezoneOffset), 1) });
  const lineColor = color || theme.colors.accent;
  const lineColorLast = addAlpha(theme.colors.contentInverseSecondary, 0.5);
  const myOptions = {
    ...defaultOptions
  };
  myOptions.scales.x.time.unit = 'month';
  myOptions.plugins.legend.display = false;
  myOptions.scales.x.adapters = {
    date: {
      locale: locale
    }
  };


  const { data: myData, isLoading, error, isSuccess } = useGetByIdAndTimeSummarizedQuery(
    {
      id: props.id,
      resourceGroupId: props.resourceGroupId,
      propertyName: 'valueDelta',
      start: state.start.toUTCString(),
      end: state.end.toUTCString(),
      summarizeBy: 'month'
    });
  const { data: myDataLast } = useGetByIdAndTimeSummarizedQuery(
    {
      id: id,
      resourceGroupId: props.resourceGroupId,
      propertyName: 'valueDelta',
      start: addMonths(state.start, -12).toUTCString(),
      end: addMonths(state.start, -1).toUTCString(),
      summarizeBy: 'month'
    });

  const chartItems = useMemo(() => mapHistoryGroupItemsToChartItemsMonth(myData ?? [], 0), [myData]);
  const chartItemsLast = useMemo(() => mapHistoryGroupItemsToChartItemsMonth(myDataLast ?? [], 12), [myDataLast]);

  const data = {
    datasets: [
      {
        ...defaultDataSet,
        id: 2,
        label: 'Value',
        data: chartItems,
        backgroundColor: lineColor,
      },
    ],
  }
  if (chartItemsLast.length > 0)
    data.datasets.unshift({
      ...defaultDataSet,
      id: 1,
      label: "last month",
      data: chartItemsLast,
      backgroundColor: lineColorLast,
    },)

    function goBack() {
      setState((prev) => ({
        start: addDays(prev.start, weekOffset - 1),
        end: addDays(prev.end, weekOffset - 1),
      }))
    }
    function goForward() {
      setState((prev) => ({
        start: addDays(prev.start, 7),
        end: addDays(prev.end, 7),
      }))
    }
  
    function goLive() {
      setState((prev) => ({ start: addMinutes(startOfDay(addDays(new Date(), weekOffset)), timezoneOffset), end: addMinutes(endOfDay(new Date()), timezoneOffset) }))
    }
  
    function onTimeChanged(item?: any) {
      if (item && item.start && item.end)
        setState((prev) => ({
          start: item.start,
          end: item.end
        }))
    }

    
  const isEmpty = myData === undefined || myData?.length === 0;

  const filename = props.objectDescription ? props.objectDescription + "_" + state.start.toDateString() + "_" + state.end.toDateString() + ".csv" : "Counter_" + state.start.toDateString() + "_" + state.end.toDateString() + ".csv";

  return (
    <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
      <Block height='100%' display='flex' flexDirection='column' width={'100%'} gridGap={theme.sizing.scale800}>
        <Block flex={1} >
          {isEmpty ?
            <NoData></NoData>
            :
            <>
              <Bar data={data} datasetIdKey='id' options={myOptions}  ></Bar>

            </>
          }
        </Block>
        {(props.showTimeNavigation === undefined || props.showTimeNavigation) &&
          <Block display={'inline-flex'} gridGap={'15px'} >
            <TimeNavigation start={state.start} end={state.end} goBack={goBack} goForward={goForward} goLive={goLive} onTimeChanged={onTimeChanged}></TimeNavigation>
            <CSVLink data={myData} filename={filename} target="_blank" ><Button size='compact' kind={KIND.secondary} > <PiFileCsvLight></PiFileCsvLight> </Button></CSVLink>
          </Block>
        }
      </Block>
    </LoadingView>
  );
}
export default BarChartMonth